export default __webpack_public_path__ + "static/media/powerExperienceIcon4.b757a5c4.webp";